var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { app: "", fixed: "" } },
    [
      _c(
        "v-layout",
        {
          staticClass: "input-container",
          attrs: { row: "", "justify-space-between": "", "ma-0": "" }
        },
        [
          _c("div", { staticClass: "container" }, [
            _c(
              "div",
              { staticClass: "select-panel" },
              _vm._l(_vm.words, function(w, index) {
                return _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isShow,
                        expression: "isShow"
                      }
                    ],
                    key: index,
                    staticClass: "select-item",
                    on: {
                      click: function($event) {
                        return _vm.click_item(_vm.words[index])
                      }
                    }
                  },
                  [
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(_vm.highlight(_vm.words[index]))
                      }
                    })
                  ]
                )
              }),
              0
            ),
            _c(
              "div",
              { ref: "textInput1", staticClass: "textInput1" },
              [
                _c(
                  "v-toolbar",
                  {
                    style: {
                      height: this.isiOS ? "18vw" : "18vw"
                    },
                    attrs: {
                      color: "white",
                      dense: this.$store.state.isRunningEmbedded,
                      flat: ""
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        ref: "textInput",
                        staticClass: "styleChange",
                        style: { width: this.clientWidth - 70 + "px" }
                      },
                      [
                        _c("v-text-field", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.shouldShowTextInput,
                              expression: "shouldShowTextInput"
                            }
                          ],
                          style: { top: "2.5vw" },
                          attrs: {
                            disabled: _vm.isLexProcessing,
                            id: "text-input",
                            name: "text-input",
                            "single-line": "",
                            "hide-details": ""
                          },
                          on: {
                            keyup: [
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.stopPropagation()
                                return _vm.postTextMessage($event)
                              },
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  ) &&
                                  _vm._k(
                                    $event.keyCode,
                                    "delete",
                                    [8, 46],
                                    $event.key,
                                    ["Backspace", "Delete", "Del"]
                                  )
                                ) {
                                  return null
                                }
                                return _vm.onEnter($event)
                              }
                            ],
                            focus: _vm.onTextFieldFocus,
                            blur: _vm.onTextFieldBlur,
                            input: _vm.debounceInput
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function() {
                                return [
                                  _c("div", { staticClass: "placeholder" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("licence.Robot_TypeHere")
                                        ) +
                                        " "
                                    )
                                  ])
                                ]
                              },
                              proxy: true
                            }
                          ]),
                          model: {
                            value: _vm.textInput,
                            callback: function($$v) {
                              _vm.textInput = $$v
                            },
                            expression: "textInput"
                          }
                        }),
                        _c("recorder-status", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.shouldShowTextInput,
                              expression: "!shouldShowTextInput"
                            }
                          ]
                        }),
                        _c(
                          "v-tooltip",
                          {
                            ref: "tooltip",
                            attrs: {
                              activator: ".input-button",
                              "content-class": "tooltip-custom",
                              left: ""
                            },
                            model: {
                              value: _vm.shouldShowTooltip,
                              callback: function($$v) {
                                _vm.shouldShowTooltip = $$v
                              },
                              expression: "shouldShowTooltip"
                            }
                          },
                          [
                            _c(
                              "span",
                              { attrs: { id: "input-button-tooltip" } },
                              [_vm._v(_vm._s(_vm.inputButtonTooltip))]
                            )
                          ]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            ref: "tooltipEndLiveChat",
                            attrs: {
                              activator: ".end-live-chat-button",
                              "content-class": "tooltip-custom",
                              left: ""
                            },
                            model: {
                              value: _vm.shouldShowEndLiveChatTooltip,
                              callback: function($$v) {
                                _vm.shouldShowEndLiveChatTooltip = $$v
                              },
                              expression: "shouldShowEndLiveChatTooltip"
                            }
                          },
                          [
                            _c(
                              "span",
                              { attrs: { id: "input-button-tooltip" } },
                              [_vm._v("End Live Chat")]
                            )
                          ]
                        ),
                        _c(
                          "v-dialog",
                          {
                            staticClass: "test2",
                            attrs: {
                              "content-class": "vdialognew",
                              attach: "vdialognew"
                            },
                            model: {
                              value: _vm.showMenu,
                              callback: function($$v) {
                                _vm.showMenu = $$v
                              },
                              expression: "showMenu"
                            }
                          },
                          [
                            _c(
                              "v-card",
                              { staticClass: "menuCard" },
                              [
                                _c("v-card-text", [
                                  _c(
                                    "div",
                                    { staticClass: "menuContainer" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "menuBtn",
                                          on: {
                                            click: function($event) {
                                              return _vm.Faq(0)
                                            }
                                          }
                                        },
                                        [
                                          _c("div", { staticClass: "menu" }, [
                                            _c("img", {
                                              style: { "margin-right": "2vw" },
                                              attrs: {
                                                src: require("../assets/appMigration@2x.png"),
                                                width: "23vw",
                                                height: "23vw"
                                              }
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  color: "#333333"
                                                }
                                              },
                                              [_vm._v("App Migration")]
                                            )
                                          ])
                                        ]
                                      ),
                                      _c("v-divider", {
                                        staticStyle: {
                                          "background-color": "#EEEEEE"
                                        }
                                      }),
                                      _c("div", { staticClass: "line" }),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "menuBtn",
                                          on: {
                                            click: function($event) {
                                              return _vm.Faq(1)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "menu" },
                                            [
                                              _c("img", {
                                                style: {
                                                  "margin-right": "2vw"
                                                },
                                                attrs: {
                                                  src: require("../assets/appOperation@2x.png"),
                                                  width: "23vw",
                                                  height: "23vw"
                                                }
                                              }),
                                              _c(
                                                "v-text",
                                                {
                                                  staticStyle: {
                                                    color: "#333333"
                                                  }
                                                },
                                                [_vm._v("App Operation")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _c("v-divider", {
                                        staticStyle: {
                                          "background-color": "#EEEEEE"
                                        }
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "menuBtn",
                                          on: {
                                            click: function($event) {
                                              return _vm.Faq(2)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "menu" },
                                            [
                                              _c("img", {
                                                style: {
                                                  "margin-right": "2vw"
                                                },
                                                attrs: {
                                                  src: require("../assets/deviceProblems@2x.png"),
                                                  width: "23vw",
                                                  height: "23vw"
                                                }
                                              }),
                                              _c(
                                                "v-text",
                                                {
                                                  staticStyle: {
                                                    color: "#333333"
                                                  }
                                                },
                                                [_vm._v("Device Problems")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _c("v-divider", {
                                        staticStyle: {
                                          "background-color": "#EEEEEE"
                                        }
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "menuBtn",
                                          on: {
                                            click: function($event) {
                                              return _vm.Faq(3)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "menu" },
                                            [
                                              _c("img", {
                                                style: {
                                                  "margin-right": "2vw"
                                                },
                                                attrs: {
                                                  src: require("../assets/helpCenter@2x.png"),
                                                  width: "23vw",
                                                  height: "23vw"
                                                }
                                              }),
                                              _c(
                                                "v-text",
                                                {
                                                  staticStyle: {
                                                    color: "#333333"
                                                  }
                                                },
                                                [_vm._v("Help Center")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm.isModeLiveChat
                          ? _c(
                              "v-btn",
                              _vm._g(
                                {
                                  ref: "endLiveChat",
                                  staticClass: "end-live-chat-button",
                                  attrs: { "aria-label": "End Live Chat" },
                                  on: { click: _vm.onEndLiveChatClick }
                                },
                                _vm.tooltipEndLiveChatEventHandlers
                              ),
                              [
                                _c("v-icon", { attrs: { medium: "" } }, [
                                  _vm._v("call_end")
                                ])
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm.shouldShowSendButton
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "icon-color input-button",
                            attrs: {
                              disabled: _vm.isLexProcessing,
                              dark: "",
                              icon: ""
                            },
                            on: {
                              click: _vm.postTextMessage,
                              touchstart: function($event) {
                                return _vm.subtouchStart($event, _vm.index)
                              }
                            }
                          },
                          [
                            _c("img", {
                              style: {
                                width: "9vw",
                                height: "9vw",
                                marginTop: "2vw"
                              },
                              attrs: {
                                src: require("../assets/sendmsgL@2x.png")
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    !_vm.shouldShowSendButton && !_vm.isModeLiveChat
                      ? _c(
                          "v-btn",
                          {
                            ref: "mic",
                            staticClass: "icon-color input-button",
                            attrs: {
                              disabled: _vm.isMicButtonDisabled,
                              icon: "",
                              dark: ""
                            },
                            on: { click: _vm.onMsgClick }
                          },
                          [
                            _c("img", {
                              style: {
                                width: "9vw",
                                height: "9vw",
                                marginTop: "2vw"
                              },
                              attrs: { src: require("../assets/more@2x.png") }
                            })
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }